import { render, staticRenderFns } from "./UnitGroupDetail.vue?vue&type=template&id=8384a90a&scoped=true"
import script from "./UnitGroupDetail.vue?vue&type=script&lang=js"
export * from "./UnitGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./UnitGroupDetail.vue?vue&type=style&index=0&id=8384a90a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8384a90a",
  null
  
)

export default component.exports